import { Component, Event, type EventEmitter, Prop, h, State, Listen } from '@stencil/core';
import { setButtonText } from './back-button-helpers';
import type { labelProviderInterface } from '../../../../LabelProviderInterface';
import EventEmitterComponent from '../event-emitter-component/event-emitter-component';

@Component({
  tag: 'uiaas-search-widget-conversational-search-back-button',
  styleUrl: 'back-button.scss',
  shadow: true,
})
export class ConversationalSearchBackButton {
  @Prop() readonly query: string;
  @Prop() readonly labelProvider: labelProviderInterface;

  @State() isCtaActivated: boolean;
  @State() ctaText;
  @State() ctaIndentifier;

  constructor() {
      this.updateCta = this.updateCta.bind(this);
  }

  @Listen('resize', { target: 'window' })
  handleResize() {
      this.updateButtonText();
  }

  @Listen('conversational-search:chat-visibility', { target: 'window' })
  handleCtaActions() {
      this.isCtaActivated = true;
      this.updateButtonText();
  }

  @Event({
    eventName: 'conversational-search:chat-visibility',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
    chatVisibilityEventEmitter: EventEmitter<{ isChatVisible: boolean }>;

  private updateCta(ctaText, ctaIndentifier) {
      this.ctaText = ctaText;
      this.ctaIndentifier = ctaIndentifier;
  }

  private updateButtonText() {
      setButtonText(this.labelProvider, this.updateCta);
  }

  connectedCallback() {
      this.updateButtonText();
  }

  componentDidUpdate() {
      this.updateButtonText();
  }

  render() {
      return (
        <EventEmitterComponent
          eventName='conversational-search:ga-cta'
          ctaName={this.ctaIndentifier}
          keyword={this.query}
        >
          <qds-button
            importance="subdued"
            onClick={() => this.chatVisibilityEventEmitter.emit({ isChatVisible: false })}
            icon-name={'arrow-left'}
            icon-library={'default'}
            text={this.ctaText}
          />
        </EventEmitterComponent>
      );
  }
}
